module.exports = __webpack_public_path__ + "static/media/ehealth-bg3-4-3.7e0df969.jpg";